import React, {useEffect, useState} from 'react';

interface IUsePortalDom {
  targetClassName?:string;
  parentElement:HTMLElement;
}

export default (props:IUsePortalDom)=>{
  const {targetClassName, parentElement} = props;

  const [target, setTarget] = useState(null as HTMLElement | null);
  useEffect(()=>{
    let dom = window.document.createElement('div')! as HTMLElement;
    dom.className = targetClassName || "";
    setTarget(dom);
    if(parentElement) {
      parentElement.appendChild(dom);
    }

    return ()=>{
      if(parentElement) {
        parentElement.removeChild(dom);
      }
    }
  }, []);

  return target;
}
